import { feedSearch } from "./feed-search";
import { pagination } from "./pagination";

export const initEventFeedSearch = () => {
    const form = document.querySelector<HTMLFormElement>(
        '[data-selector="eventfeed-search-form"]',
    );

    if (!form) return;

    feedSearch({
        formSelector: '[data-selector="eventfeed-search-form"]',
        resultsContainerSelector:
            '[data-selector="eventfeed-search-results-list"]',
        highlightedEntriesWrapperSelector:
            '[data-selector="eventfeed-highlighted-entries"]',
    });

    pagination({
        loadMoreButtonSelector: '[data-selector="eventfeed-load-more"]',
        resultsContainerSelector:
            '[data-selector="eventfeed-search-results-list"]',
    });
};
